'use strict';

// AngularJS will instantiate a singleton by calling "new" on this function
export function LanguageService($locale, $http, gettextCatalog, localStorageService, Auth) {
  'ngInject';

  var _lang = {
    supportedLanguages: ['en', 'fr'], //Add the supported languages by MySign in this array
    lang: 'fr', //by default, set the this.lang cookie in english but we might change it

    init() {
      //console.log('Language initialization');
      var lsLang = localStorageService.get('this.lang');

      //If the cookie this.lang is not set, try to fetch the language of the navigator, otherwise, we use english.
      if(!lsLang) {
        var language = window.navigator.language || window.navigator.userLanguage;
        language = language.substr(0, 2); // get the this.lang to the ISO639-1 format
        //console.info('Cookie this.lang not set, language found', language);
        if(this.supportedLanguages.indexOf(language) !== -1) {
          localStorageService.set('this.lang', language);
        } else {
          localStorageService.set('this.lang', this.lang);
        }
      }

      gettextCatalog.baseLanguage = 'fr'; //the labels in the app are written in english
      this.set(localStorageService.get('this.lang'), true);
    },

    get() {
      return this.lang;
    },

    set(language, isInit) {
      //console.info('Set language', language);
      if(this.supportedLanguages.indexOf(language) === -1) {
        //console.warn('Language not supported', language);
        return;
      }
      this.lang = language;
      $locale.id = this.lang;
      localStorageService.set('this.lang', language);

      //console.log('Apply language');
      if(language === 'fr') {
        gettextCatalog.setStrings(language, {});
        gettextCatalog.setCurrentLanguage(language);
      } else {
        //gettextCatalog.loadRemote("assets/translations/template.json");
        gettextCatalog.setCurrentLanguage(language);
      }

      if(!isInit && Auth.isLoggedInSync()) {
        $http.put('api/users/me', {
          language
        }).catch(err => {
          console.log('Error language');
        });
      }
    }

  };
  return _lang;
}



// WEBPACK FOOTER //
// ./client/components/language/language.service.js